var map = {
	"./layout_app/layout_app.module": [
		"./src/app/layout_app/layout_app.module.ts",
		"common",
		"layout_app-layout_app-module"
	],
	"./layout_portal/layout_portal.module": [
		"./src/app/layout_portal/layout_portal.module.ts",
		"common",
		"layout_portal-layout_portal-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;